import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import profilePic from './profile-pic.jpeg'

import Avatar from 'material-ui/Avatar';
import Octicon from 'react-octicon'
import FontIcon from 'material-ui/FontIcon';

class Intro extends React.Component {
  render() {
    return (
      <div>
        <p
          style={{
            marginBottom: rhythm(1.5),
          }}
        >

          <span><FontIcon className="material-icons" >bookmark</FontIcon> 101 Series: </span>
          Getting started with the most commonly used functions/tools.
        <br />
          <span><FontIcon className="material-icons" >bookmark</FontIcon> Docker Series: </span>
          Docker for deploy, build, etc.

        </p>
      </div>
    )
  }
}

export default Intro


// WEBPACK FOOTER //
// ../components/Intro.js